<template>
  <div class="profile-info">
    <div class="profile-info-desc">
      <p class="c-title-bold--m">
        業務情報を見直すと、発想のヒントがもっと役立ちます
      </p>
      <ul class="c-text-regular--m">
        <li>
          専門領域や課題を最新にするほど、より的確な着眼点・仮説・推奨アクションを提案します。
        </li>
        <li>
          業務情報の見直し後は、こちらの画面で発想のヒントを再生成できます。
        </li>
      </ul>
    </div>
    <RouterLink
      to="/settings/profile"
      type="button"
      class="profile-info-action c-btn c-btn--auto c-btn--small"
    >
      業務情報を見直す
    </RouterLink>
  </div>
</template>

<style lang="scss" scoped>
.profile-info {
  display: flex;
  padding: 16px;
  margin-top: 8px;
  border-radius: 4px;
  background: $color-green100;

  ul {
    padding-left: 20px;
  }

  .profile-info-action {
    margin-left: auto;
    border: none;
    background: $color-white;
    &:hover {
      background: $color-gray200;
    }
  }
}
</style>
